import { configureStore } from '@reduxjs/toolkit';
import sidebarReducer from './slices/sidebarSlice';
import locationsReducer from './slices/locationSlice';
import eventsReducer from './slices/eventSlice';
import usersReducer from './slices/usersSlice';
import customersReducer from './slices/customersSlice';
import historyReducer from './slices/historySlice';
import matchingsReducer from './slices/matchingSlice';
import templatesReducer from './slices/templatesSlice';
import imagesReducer from './slices/imagesSlice';
import webSocketReducer from './slices/webSocketSlice';
import { socketMiddleware } from './service/webSocket';
import homeReducer from './slices/homeSlice'
import scheduleReducer from './slices/scheduleSlice';
import authReducer from './slices/authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    matchings: matchingsReducer,
    sidebar: sidebarReducer,
    locations: locationsReducer,
    users: usersReducer,
    customers: customersReducer,
    history: historyReducer,
    templates: templatesReducer,
    webSocket: webSocketReducer,
    events: eventsReducer,
    images: imagesReducer,
    home: homeReducer,
    schedules: scheduleReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(socketMiddleware) // Add the WebSocket middleware
});

export default store;
